// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3923) return "static/chunks/3923-787ded189b4bb83b.js";
	if (chunkId === 3759) return "static/chunks/3759-5cf46c08547a5ec2.js";
	if (chunkId === 145) return "static/chunks/145-38608dfcaacea47a.js";
	if (chunkId === 7868) return "static/chunks/7868-6e71fb99bcf688ce.js";
	if (chunkId === 4875) return "static/chunks/4875-d6c11e7453ff8e0c.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1521":"9188baa42eec3759","2147":"c613fb63c3ea7565","4258":"ed53e6662ff06b5c","6394":"bd9014fc4b0bc3d7","7822":"46d8fdf4be7d8e2c","7884":"6d8c1af2d0f84fac","9185":"60aa57df11c6103b","9386":"07144d55cd3e864b","9671":"232ec585d5d9ce15"}[chunkId] + ".js";
};